import React, { FC, useContext } from "react"
import L10n from "lib/carrot-l10n"
import { Spacer } from "../../atoms/Atoms"
import { Body } from "../../atoms/Bodies"
import { MessageTextArea, SendMessageEmailInput } from "../../talktocarrot/sendmessage/SendMessageForm"
import { SendMessageFormContext } from "../../../containers/talktocarrot/SendMessageFormContainer"
import { ThankYou } from "../../talktocarrot/sendmessage/ThankYou"
import { BenefitEnrollmentFlowModalBackButton, useBenefitEnrollmentFlow } from "./BenefitEnrollmentFlowModal"
import { useProgressTracker } from "../ProgressTracker"
import { Steps } from "./Workflow/Steps"
import { useFormContext } from "react-hook-form"
import { ButtonPrimary } from "../../atoms/buttons/ButtonPrimary"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { getHeap } from "../../../../utils/heap"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

interface TalkToCarrotBenefitEnrollmentFlowViewProps {
  onExit: () => void
}
const ViewName = Steps.TALK_TO_CARROT

const TalkToCarrotBenefitEnrollmentFlowView: FC<TalkToCarrotBenefitEnrollmentFlowViewProps> = () => {
  const { setProgress } = useProgressTracker()
  const { sent, onSubmit } = useContext(SendMessageFormContext)
  const {
    formState: { isValid, isSubmitting }
  } = useFormContext()
  const { onExit } = useBenefitEnrollmentFlow()

  useStateMachine(ViewName, null)
  setProgress(1, "YOUR INSURANCE COVERAGE")

  const sendSupportRequest = () => {
    onSubmit()
    getHeap().track("EnrollmentFlowSupportRequest", { EventName: "I'm not sure" })
  }

  return (
    <>
      {sent ? (
        <ThankYou showHeader={false} showBottomLine={false} onClick={() => onExit()} />
      ) : (
        <>
          <BenefitEnrollmentFlowModalBackButton />
          <Spacer height={1} />
          <H2 variant="dark">{l`It looks like you weren’t sure how to answer the last question. That’s ok.`}</H2>
          <Spacer height={1} />
          <Body color="black-80">{l`But we still need this information in order to reimburse you. Tell us what you weren’t
        sure about about or what we can help clarify. The more detail you can provide, the better.`}</Body>
          <Spacer height={2.5} />
          <SendMessageEmailInput showUpdateContactInfo={false} />
          <Spacer height={2} />
          <MessageTextArea showPlaceholderText={false} rows="3" />
          <div className="flex flex-row justify-end">
            <ButtonPrimary
              onClick={sendSupportRequest}
              enabled={isValid && !isSubmitting}
              disabledBackgroundColor="black-10"
            >
              {isSubmitting ? l`client.sending` : l`client.chat.submit`}
            </ButtonPrimary>
          </div>
        </>
      )}
    </>
  )
}

export { TalkToCarrotBenefitEnrollmentFlowView }
